export const PROJECTS = {
  VIRIG: {
    TITLE: 'Character Rig: Vi from Arcane',
    VIDEO:
      'https://player.vimeo.com/video/1058559382?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'A detailed character rig featuring advanced limb control systems, dynamic secondary animations, and motion capture integration. This project showcases technical rigging through custom tool development and successful mocap data processing, demonstrating versatility in both rigging and animation workflows.',
  },
  MODULARRIGTOOL: {
    TITLE: 'Modular Rigging Tool',
    VIDEO:
      'https://player.vimeo.com/video/1069119061?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'A Python-based character rigging system for Maya that streamlines the rigging process through modular components and a guide-based workflow. This tool enables technical artists to create production-ready character rigs in a fraction of the time required for manual rigging.',
  },
  GUIDINGLIGHT: {
    TITLE: 'Guiding Light',
    VIDEO:
      'https://player.vimeo.com/video/950467791?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'In this project, I showcased my skills in C++ game programming and technical art through various contributions to "Guiding Light." My work encompassed several key areas:',
  },
  INNFORTHELOST: {
    TITLE: 'Inn For the Lost',
    VIDEO: '',
    DESCRIPTION: 'Coming soon...',
  },
  LOCKINGDOORS: {
    TITLE: 'Locking Doors',
    VIDEO:
      'https://player.vimeo.com/video/832988407?h=725303ed43&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'Monthly Game Mechanic Challenge hosted by CG Spectrum where we had two weeks to complete the challenge using the assets provided. I wanted to start refining my code and explore different solutions for handling interaction interfaces, inventory systems, data tables, and the UI.',
  },
  LUXLABYRINTH: {
    TITLE: 'Lux Labyrinth',
    VIDEO:
      'https://player.vimeo.com/video/843629048?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'Monthly Game Mechanic Challenge hosted by CG Spectrum where we had three weeks to complete the challenge of getting a ball through a hoop.',
  },
  STEAMPUNK_RPG: {
    TITLE: 'Automaton Alpha',
    VIDEO:
      'https://player.vimeo.com/video/825841309?h=eec0b57a38&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'A steampunk-themed RPG using C++ and Unreal Engine 5.1. Currently includes an equipment system, attack system, player stats, Enemy AI, and UI elements.',
  },
  TANTRUMN: {
    TITLE: 'Tantrumn',
    VIDEO:
      'https://player.vimeo.com/video/837390479?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    DESCRIPTION:
      'A multiplayer race to the finish! Traverse through the obstacles using any power-ups you find to give you the advantage over your opponent. Made during my second term of the Game Programming course at CG Spectrum (12 weeks), and I focused on the multiplayer split-screen and race against the AI game modes.',
  },
};
